// extracted by mini-css-extract-plugin
export var container = "_gz-0";
export var dotAnimation = "_gz-2";
export var dotsLoading = "_gz-1";